import { render, staticRenderFns } from "./RecipeItemStepDelete.vue?vue&type=template&id=68318fa9&"
import script from "./RecipeItemStepDelete.vue?vue&type=script&lang=js&"
export * from "./RecipeItemStepDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports